export default [
  {
    path: '/user-guidance',
    name: 'user-guidance',
    component: () => import( /* webpackChunkName: "user-guidance" */  '../views/user-guidance/index'),
    meta: {
      name: '后台首页',
      keepAlive: true
    }
  }
]
